import { ButtonProps } from '@/components/ui/button/button';
import { env } from '@/config/env';

import type { HeroData } from '../../hooks';
import type { HeroStateCallbacks } from '../../utils/hero-state-parser';

import HERO_STATES_V2_OFFLINE, {
  DEFAULT_HERO_STATE_OFFLINE,
} from './hero-states-v2.offline';
import HERO_STATES_V2_ONLINE, {
  DEFAULT_HERO_STATE_ONLINE,
} from './hero-states-v2.online';

const isOffline = env.IS_OFFLINE;

export type Cta = {
  variant: ButtonProps['variant'];
  label: string;
  onClick: () => void | Promise<void>;
};

export type HeroStateConfig = {
  id: string;
  name: string;

  // State condition checker
  isEnabled: (heroData: HeroData) => boolean;
  hasError?: (heroData: HeroData) => boolean;

  // Prop generators
  getTitle: (heroData: HeroData) => string;
  getSubtitle?: (heroData: HeroData) => string;
  getStats?: (heroData: HeroData) => React.ReactNode;
  getDivider?: (heroData: HeroData) => boolean;
  getOverButton?: (heroData: HeroData) => string;
  getCta?: (heroData: HeroData, callbacks?: HeroStateCallbacks) => Cta;
  getCharacterImage?: (heroData: HeroData) => string;
};

export const DEFAULT_HERO_STATE: HeroStateConfig = isOffline
  ? DEFAULT_HERO_STATE_OFFLINE
  : DEFAULT_HERO_STATE_ONLINE;

export const HERO_STATES_V2: HeroStateConfig[] = isOffline
  ? HERO_STATES_V2_OFFLINE
  : HERO_STATES_V2_ONLINE;
